// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__UjMjJ","range":"MonthRangeSwitch_range__2ueoL","disabled":"MonthRangeSwitch_disabled__1jCZY"};